import type { TypeStyleData } from './types';

import toArray from '../toArray';

import removeStyle from './removeStyle';
import setStyle from './setStyle';
import setStyleData from './setStyleData';

// ----------------------------------------------------------------------------

declare global {
    interface HTMLElement {
        removeStyle(data: string | string[]): HTMLElement;
        setStyle(key: string, value: string, priority?: '' | 'important'): HTMLElement;
        setStyleData(data: TypeStyleData): HTMLElement;
    }
    interface NodeList {
        removeStyle(data: string | string[]): NodeList;
        setStyle(key: string, value: string, priority?: '' | 'important'): NodeList;
        setStyleData(data: TypeStyleData): NodeList;
    }
}

// ----------------------------------------------------------------------------

HTMLElement.prototype.removeStyle = function (data: string | string[]): HTMLElement {
    removeStyle(this, data);

    return this;
};

NodeList.prototype.removeStyle = function (data: string | string[]): NodeList {
    for (const element of toArray(this)) {
        if (element instanceof HTMLElement) {
            removeStyle(element, data);
        }
    }

    return this;
};

// ----------------------------------------------------------------------------

HTMLElement.prototype.setStyle = function (key: string, value: string, priority?: '' | 'important'): HTMLElement {
    setStyle(this, key, value, priority);

    return this;
};

NodeList.prototype.setStyle = function (key: string, value: string, priority?: '' | 'important'): NodeList {
    for (const element of toArray(this)) {
        if (element instanceof HTMLElement) {
            setStyle(element, key, value, priority);
        }
    }

    return this;
};

// ----------------------------------------------------------------------------

HTMLElement.prototype.setStyleData = function (data: TypeStyleData): HTMLElement {
    setStyleData(this, data);

    return this;
};

NodeList.prototype.setStyleData = function (data: TypeStyleData): NodeList {
    for (const element of toArray(this)) {
        if (element instanceof HTMLElement) {
            setStyleData(element, data);
        }
    }

    return this;
};
